import React from 'react';
import { AbsenceColleague } from '../../Content';
import { TeamCalendarFiltersType } from './types';
import TeamCalendarMultipleFilter from './TeamCalendarMultipleFilter';
import { useObjectLabels } from '../../../../../hooks/useObjectLabels';

type Props = {
  colleagues: AbsenceColleague[];
  filterData: TeamCalendarFiltersType;
};

const ColleagueFilter: React.FC<React.PropsWithChildren<Props>> = ({
  colleagues,
  filterData,
}) => {
  const objectLabels = useObjectLabels();

  return (
    <div className="small fw-normal">
      <TeamCalendarMultipleFilter
        filterData={filterData}
        options={colleagues.map((c) => ({ label: c.name, value: c.id }))}
        filterKey={'colleaguesIds'}
        placeholder={objectLabels.employeePlural}
        menuPlacement={'bottom'}
        menuPosition={'fixed'}
      />
    </div>
  );
};
export default ColleagueFilter;
